/**
 * @file
 * Attaches the behaviors for locations landing.
 */

(function (Drupal) {
  'use strict';

  Drupal.behaviors.locationsLanding = {
    attach(context) {
      const self = this;
      $('#hunterdon-locations-form', context).each(function () {
        self.$form = $(this);
        self.$useMyLocation = $(
          '.locations-landing__form--search__proximity--geolocation .form-item__checkbox',
          self.$form
        );
        self.$proximity = $('#edit-proximity', self.$form);
        self.$currentLocation = $(
          '.locations-landing__form--search__proximity--current',
          self.$form
        );
        self.$currentLocation.hide();
        self.$closeCurrentLocation = $('button', self.$currentLocation);
        self.$closeCurrentLocation.click((e) => {
          // e.preventDefault(); // otherwise submits the form
          self.$useMyLocation.prop('checked', false);
          self.dontUseMyLocation();
        });
        self.$lat = $('.locations-landing__form--search #lat', self.$form);
        self.$lng = $('.locations-landing__form--search #lng', self.$form);
        self.$sort = $('.locations-landing__count #edit-sort', self.$form);
        if (navigator.geolocation) {
          if (self.$useMyLocation.prop('checked')) {
            self.useMyLocation();
          }
          self.$useMyLocation.change(function () {
            if (self.$useMyLocation.is(':checked')) {
              self.useMyLocation(true);
            }
            else {
              self.dontUseMyLocation();
            }
          });
        }
        else {
          self.$useMyLocation.parent().hide();
        }
      });

      nakedFormSelect('select', {
        keywordSearch: {
          on: true,
          placeholder: 'Enter keyword'
        }
      });

      const filterToggle = document.querySelector(
        '.locations-landing__filters--title',
        context
      );
      const filterWrap = document.querySelector(
        '.locations-landing__filters--inner'
      );

      filterToggle.addEventListener('click', function () {
        if (filterToggle.classList.contains('is-active')) {
          filterWrap.classList.remove('is-active');
          filterToggle.classList.remove('is-active');
        }
        else {
          filterWrap.classList.add('is-active');
          filterToggle.classList.add('is-active');
        }
      });

      if (document.querySelector('.btn-remove')) {
        document.querySelector('.btn-remove').style.display = 'none';
      }

      const selection = document.querySelectorAll('.match');
      selection.forEach((item) => {
        item.addEventListener('click', () => {
          this.$form.submit();
        });
      });
    },
    useMyLocation(submitForm = false) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.$lat.val(position.coords.latitude);
          this.$lng.val(position.coords.longitude);
          this.$sort.val('dist');
          this.$useMyLocation.parent().parent().addClass('using-location');
          this.$currentLocation.show();
          this.$proximity.val(null);
          this.$proximity.parent().hide();

          if (submitForm) {
            this.$form.submit();
          }
        },
        () => {
          this.$useMyLocation.prop('checked', false);
          this.dontUseMyLocation();
        },
        {
          timeout: 10 * 1000
        }
      );
    },
    dontUseMyLocation() {
      this.$lat.val(null);
      this.$lng.val(null);
      this.$useMyLocation.parent().parent().removeClass('using-location');
      this.$proximity.parent().show();
      this.$currentLocation.hide();
    }
  };

  Drupal.behaviors.locationsLandingTypeahead = {
    attach(context) {
      // Search text autocomplete.
      let s1 = new autoComplete({
        selector:
          '.locations-landing__form input[data-drupal-selector=edit-keys]',
        menuClass: 'autocomplete',
        minChars: 4,
        delay: 250,
        source: function source(term, response) {
          $.getJSON(
            '/locations/suggest',
            {
              keys: term,
              type: 'location'
            },
            function (data) {
              response(data);
            }
          );
        },
        renderItem: function renderItem(item, search) {
          const url = item.url;
          item = item.title;
          search = search.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
          const re = new RegExp('(' + search.split(' ').join('|') + ')', 'gi');
          return (
            '<div class="autocomplete-suggestion" data-url="' +
            url +
            '" data-val="' +
            item +
            '">' +
            item.replace(re, '<b>$1</b>') +
            '</div>'
          );
        },
        onSelect: function onSelect(event, term, item) {
          window.location = item.getAttribute('data-url');
        }
      });
      // Search text autocomplete.
      let s2 = new autoComplete({
        selector:
          '.locations-landing__form input[data-drupal-selector=edit-proximity]',
        menuClass: 'autocomplete',
        minChars: 4,
        delay: 250,
        source: function source(term, response) {
          $.getJSON(
            '/locations/suggest-city',
            {
              keys: term,
              type: 'location'
            },
            function (data) {
              response(data);
            }
          );
        },
        renderItem: function renderItem(item, search) {
          const url = item.url;
          item = item.title;
          search = search.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
          const re = new RegExp('(' + search.split(' ').join('|') + ')', 'gi');
          return (
            '<div class="autocomplete-suggestion" data-url="' +
            url +
            '" data-val="' +
            item +
            '">' +
            item.replace(re, '<b>$1</b>') +
            '</div>'
          );
        },
        onSelect: function onSelect(event, term, item) {
          window.location = item.getAttribute('data-url');
        }
      });
    }
  };
})(Drupal);
